import { FC } from 'react';
import { User } from '../../../types/User';
import { getDateShortFormat } from '../../../../../utils/dates';

interface Props {
    user: User;
}

interface DetailsProps {
    label: string;
    value: string;
}

const Details: FC<DetailsProps> = ({ label, value }) => (
    <div className="flex flex-col gap-2">
        <span className="font-sf text-13 leading-[15.51px] text-sf-gray-500">{label}</span>
        <span className="font-sf text-13 leading-[15.51px]">{value}</span>
    </div>
);

const DetailsSection: FC<Props> = ({ user }) => {
    const lastSeenText = user.lastAccess ? getDateShortFormat(user.lastAccess) : 'N/A';

    return (
        <div className="px-4 flex gap-20">
            <Details label="UPN" value={user.upn ?? 'N/A'} />
            <Details label="Domain" value={user.domainName} />
            <Details label="Last seen" value={lastSeenText} />
        </div>
    );
};

export default DetailsSection;
